/* istanbul ignore file */
import { FormRow } from 'framework/ui/layout';
import { TextArea, EnumDropdown, ClearAfterUnmountWrapper } from 'framework/form';
import VacancyOfficeDropdown from 'domain/recruiting/vacancy/shared/input/VacancyOfficeDropdown';
import { EMPLOYEE_CONTRACT_ASSIGMENT_TYPES } from 'domain/shared/employee';
import { EMPLOYEE_WORKPLACE_LOCATION } from 'domain/shared/employee';
import {
  RELOCATION_OPTIONS,
  VACANCY_EMPLOYEE_CONTRACT_TYPES_NO_INTERNSHIP,
  VACANCY_HAS_PROBATION_OPTIONS,
  WORKING_SCHEDULE,
} from 'domain/recruiting/vacancy/shared/vacancyService';
import { get } from 'lodash';

interface VacancyQualificationInputProps {
  source: string;
}

const VacancyDetailsInput = ({ source, ...props }: VacancyQualificationInputProps) => {
  return (
    <div className="vacancy-details-field__wrapper">
      <FormRow>
        <VacancyOfficeDropdown source={`${source}.office`} label="Location (Office)" isAnywhereAvailable />
      </FormRow>
      <FormRow>
        <EnumDropdown
          options={EMPLOYEE_CONTRACT_ASSIGMENT_TYPES}
          source={`${source}.assignmentType`}
          label="Employment type"
          multiple
          placeholder="Choose employement types"
        />
        <EnumDropdown
          source={`${source}.relocationOption`}
          label="Relocation Option"
          options={RELOCATION_OPTIONS}
          placeholder="Choose relocation option"
        />
        <EnumDropdown
          source={`${source}.hasProbation`}
          label="Probation"
          options={VACANCY_HAS_PROBATION_OPTIONS}
          placeholder="Choose option"
        />
      </FormRow>
      <FormRow>
        <EnumDropdown
          options={VACANCY_EMPLOYEE_CONTRACT_TYPES_NO_INTERNSHIP}
          source={`${source}.contractType`}
          label="Contract Type"
          multiple
          placeholder="Choose contract types"
        />
        <EnumDropdown
          options={EMPLOYEE_WORKPLACE_LOCATION}
          source={`${source}.workplaceLocation`}
          label="Working mode"
          multiple
          placeholder="Choose working modes"
        />
        <EnumDropdown
          source={`${source}.workingSchedule`}
          label="Working schedule"
          options={WORKING_SCHEDULE}
          placeholder="Choose working schedule"
        />
        <ClearAfterUnmountWrapper isVisible={vacancy => get(vacancy, source).workingSchedule === 'NON_STANDARD'}>
          <TextArea rows={2} source={`${source}.workingScheduleDescription`} />
        </ClearAfterUnmountWrapper>
      </FormRow>
    </div>
  );
};

export default VacancyDetailsInput;
